import { Validators } from '@angular/forms';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import moment = require('moment');

export const individual_subject_form_keys: IFormKey[] = [
  {
    id: 'name-field',
    label: 'Nome',
    controlName: 'name',
    css: 'col-4',
    type: 'INPUT',
  },
  {
    id: 'surname-field',
    label: 'Cognome',
    controlName: 'surname',
    css: 'col-4',
    type: 'INPUT',
  },
  {
    id: 'taxCode-field',
    label: 'Codice fiscale',
    controlName: 'taxCode',
    css: 'col-4',
    type: 'INPUT',
    uppercase: true,
  },
  {
    id: 'birth-date',
    controlName: 'birthDate',
    label: 'Data di nascita',
    css: 'col-4',
    type: 'DATEPICKER',
    maxDate: moment(),
  },
  {
    id: 'sex-field',
    label: 'Sesso',
    controlName: 'sex',
    css: 'col-4',
    type: 'SELECT',
    options: [
      {
        key: 'M',
        value: 'Maschio',
      },
      {
        key: 'F',
        value: 'Femmina',
      },
    ],
  },
  {
    id: 'citizenship-field',
    label: 'Nazionalità',
    controlName: 'citizenship',
    css: 'col-4',
    type: 'SELECT',
    options: [],
  },
];

export const individual_subject_form_template = {
  taxCode: null,
  name: null,
  surname: null,
  birthDate: null,
  citizenship: null,
  sex: null,
};

export const individual_subject_form_validators = {
  taxCode: [
    Validators.required,
    Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/),
  ],
  name: [Validators.required],
  surname: [Validators.required],
  birthDate: [Validators.required],
  citizenship: [Validators.required],
  sex: [Validators.required],
};

export const birth_subject_form_keys: IFormKey[] = [
  {
    id: 'birthCountry-field',
    label: 'Nazione',
    controlName: 'birthCountry',
    css: 'col-3',
    type: 'SELECT',
    options: [],
  },
  {
    id: 'birthProvince-field',
    label: 'Provincia',
    controlName: 'birthProvince',
    css: 'col-3',
    type: 'SELECT',
    options: [],
  },
  {
    id: 'birthPlace-field',
    label: 'Città',
    controlName: 'birthPlace',
    css: 'col-3',
    type: 'SELECT',
    options: [],
  },
];

export const birth_subject_form_template = {
  birthCountry: null,
  birthProvince: null,
  birthPlace: null,
};

export const birth_subject_form_validators = {
  birthPlace: [Validators.required],
  birthProvince: [Validators.required],
  birthCountry: [Validators.required],
};

export const residence_subject_form_keys: IFormKey[] = [
  {
    id: 'country-field',
    label: 'Nazione',
    controlName: 'residenceCountry',
    css: 'col-3',
    type: 'SELECT',
    options: [],
  },
  {
    id: 'province-field',
    label: 'Provincia',
    controlName: 'residenceProvince',
    css: 'col-3',
    type: 'SELECT',
    options: [],
  },
  {
    id: 'place-field',
    label: 'Città',
    controlName: 'residencePlace',
    css: 'col-3',
    type: 'SELECT',
    options: [],
  },
  {
    id: 'postalCode-field',
    label: 'CAP',
    controlName: 'residencePostalCode',
    css: 'col-3',
  },
  {
    id: 'toponym-field',
    label: 'Toponimo (via, corso,...)',
    controlName: 'residenceToponym',
    css: 'col-3',
  },
  {
    id: 'address-field',
    label: 'Indirizzo',
    controlName: 'residenceAddress',
    css: 'col-3',
  },
  {
    id: 'address-number-field',
    label: 'Numero Civico',
    controlName: 'residenceAddressNumber',
    css: 'col-3',
  },
];

export const residence_subject_form_template = {
  residenceCountry: null,
  residenceProvince: null,
  residencePlace: null,
  residenceToponym: null,
  residenceAddress: null,
  residenceAddressNumber: null,
  residencePostalCode: null,
};

export const residence_subject_form_validators = {
    residenceCountry: [Validators.required],
    residenceProvince: [Validators.required],
    residencePlace: [Validators.required],
    residencePostalCode: [Validators.required, Validators.pattern(/^\d{5}$/)],
    residenceToponym: [Validators.required],
    residenceAddress: [Validators.required],
    residenceAddressNumber: [Validators.required]
}

export const BIRTH_HIDDEN_FIELD_FOREIGN_STATE_SUBJECT = ['birthProvince', 'birthPlace'];
export const HIDDEN_FIELD_FOREIGN_STATE_SUBJECT = ['residenceProvince', 'residencePlace', 'residencePostalCode'];
